import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../Navbar";
import Dropdown from "./Dropdown";

export default function BuyAndSellBonds({ user }) {
    const navigate = useNavigate();

    const goNext = () => {
        navigate("/MutualFunds");
    };

    const goPrev = () => {
        navigate("/BondsDef");
    };

    return (
        <div className="h-screen overflow-hidden">
            <Navbar user={user} />
            <Dropdown />
            <div className="w-full flex flex-col justify-center items-center overflow-hidden">
                <div className="text-[#000000] text-5xl m-4 font-bold">
                    Buying And Selling Bonds
                </div>
                <span className="w-full h-0.5 bg-blueInFigma"></span>
                <div className="text-[#000000] text-3xl mt-3">
                    Much like a stockbroker, a bond broker a person or firm who buys and sells 
                </div>
                <div className="text-[#000000] text-3xl">
                    bonds on behalf of an investor.  To buy a corporate bond, you must use a bond 
                </div>
                <div className="text-[#000000] text-3xl">
                    broker and deposits are very high (multiple thousand) to even start.  In the United 
                </div>
                <div className="text-[#000000] text-3xl">
                    States, to buy a government bond, you can use your local bank or a brokerage, but 
                </div>
                <div className="text-[#000000] text-3xl">
                    if neither option works, you can buy directly from the government.
                </div>
                <div className="text-[#000000] text-3xl mt-3">
                    To sell corporate bonds, you need to use a bond broker.  You can sell a 
                </div>
                <div className="text-[#000000] text-3xl">
                    government bond through a bond broker or a bank, or you can sell it back to the 
                </div>
                <div className="text-[#000000] text-3xl">
                    US government.
                </div>
            </div>
            <button className="bg-[#73C4FC] text-[#FFFFFF] p-4 absolute bottom-[10%] right-[17.5%] text-3xl rounded-2xl"
                onClick={goNext}
            >
                Next
            </button>
            <button className="bg-blueInFigma text-[#FFFFFF] p-4 absolute bottom-[10%] left-[17.5%] text-3xl rounded-2xl"
                onClick={goPrev}
            >
                Prev
            </button>
        </div>
    );
}